import { Entity } from "@rauricoste/core";
import { Pile, PileProps, Pushable } from "./Pile";

export class InfinitePile<T extends Entity> extends Pile<T> {
  constructor(public readonly generator: () => T, pileProps: PileProps<T>) {
    if (!pileProps.pile.length) {
      pileProps.pile = [generator(), generator()];
    }
    super(pileProps);
  }

  canTake(count: number): boolean {
    return true;
  }
  moveCount(to: Pushable<T>, count: number) {
    const cards = [...new Array(count)].map(this.generator);
    cards.forEach((card) => to.push(card));
    return { drawn: cards };
  }
  move<X extends T>(to: Pushable<X>, item: X) {
    const { pile: from } = this;
    const index = from.findIndex((_) => _.id === item.id);
    if (index !== -1) {
      from.splice(index, 1);
      this.pile.push(this.generator());
    }
    to.push(item);
  }
}
